import axios from "axios";
const basePath = process.env.VUE_APP_HZMB_GH_BASE_PATH;

/**
 * 准入
 * @param {*} serviceType
 * @param {*} approveNo
 * @param {*} registrationNo
 * @param {*} identificationNo
 * @param {*} mobileAreaCode
 * @param {*} mobile
 * @param {*} identType
 * @param {*} identNo
 * @returns
 */
const check = (
  serviceType,
  approveNo,
  registrationNo,
  identificationNo,
  mobileAreaCode,
  mobile,
  identType,
  identNo,
  companyRegistrationType,
  companyRegistrationNo
) => {
  return axios
    .post(`${basePath}/protected/api/v1/application/hzmbG/cancel/check`, null, {
      params: {
        serviceType,
        approveNo,
        registrationNo,
        identificationNo,
        mobileAreaCode,
        mobile,
        identType,
        identNo,
        companyRegistrationType,
        companyRegistrationNo,
      },
    })
    .then((res) => res.data);
};

/**
 * 提交
 * @param {*} id
 * @returns
 */
const submit = (applicationId, cancelReason) => {
  return axios
    .post(
      `${basePath}/protected/api/v1/application/hzmbG/cancel/submit/${applicationId}`,
      cancelReason,
      {
        headers: { "Content-Type": "text/plain" },
      }
    )
    .then((res) => res.data);
};

/**
 * 查詢詳情
 * @param {*} applicationId
 * @returns
 */
const getById = (applicationId) => {
  return axios
    .get(
      `${basePath}/protected/api/v1/application/hzmbG/cancel/${applicationId}`
    )
    .then((res) => res.data);
};

export default {
  check,
  submit,
  getById,
};
